import { render } from "./carousel-item-v2.vue?vue&type=template&id=09909ab8"
import script from "./carousel-item-v2.vue?vue&type=script&lang=js"
export * from "./carousel-item-v2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__